import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import "./style.css";
import "./style2.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faGears,
  faTicket,
  faUser,
  faUserPlus,
  faCogs,
  faPeopleArrows,
  faTable,
  faClipboard,
  faClipboardList,
} from "@fortawesome/free-solid-svg-icons";
import loadConfig from "../../../Services/Api/ApiServices";
import { useDispatch, useSelector } from "react-redux";
import { GetRoleByUserGuid } from "../../../Redux/Reducers/Shared/RoleByUser";
function NavBarManager() {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.UserInfo.UserInfo)
  const navigate = useNavigate();
  const [activeLink, setActiveLink] = useState(window.location.pathname);
  const [jsonData, setJsonData] = useState();
  const userRole = useSelector((state) =>
    state.RoleByUserGuid?.RoleByUserGuid?.map((ele) => ele?.rolesId)
  );
  console.log(userInfo, "useffffffffedfefefrRole");

  const dataJson = async () => {
    let jsonData = await loadConfig();

    setJsonData(jsonData);
  };

  useEffect(() => {
    dataJson();
     dispatch(GetRoleByUserGuid(userInfo?.userToken?.userGuid))
    // dispatch(GetRoleByUserGuid(userInfo?.userToken?.userGuid))
  }, []);

console.log(userInfo?.userToken?.userGuid,"sssssssssssssdwdwdwd");

useEffect(()=>{
  if(userInfo?.userToken?.userGuid!=undefined&&userInfo?.userToken?.userGuid!="undefined"){

    dispatch(GetRoleByUserGuid(userInfo?.userToken?.userGuid))
  }
  },[])

  // useEffect(()=>{
  //   if(userRole?.includes("059c649c-a4c6-47dc-9daa-fce7f32c51e8")){
  //     // navigate("/SRFund/report/ReportStageRequest/")
  //     setActiveLink("/SRFund/report/ReportStageRequest/")
  //   }
  // },[userRole])

  // console.log(userInfo?.userToken?.userGuid
  // ,"ssssssscsd");


  const HTML = (
    <>

      <>
        {userRole ? (
          <div className="containerr">
            <div className="input">
              {/* //
            // 

            EmployeeNormal
            //  */}
              {userRole?.includes("d9aa628b-c8ec-487b-8796-1293b942207a") ||
                userRole?.includes("73c6d8f8-0796-4eeb-a788-383e5f63f8aa") ? (
                <>
                  <Link
                    to="/SRFund/manager/TransferRequestsStatus/"
                    className={`navbar-link ${activeLink === "/SRFund/manager/TransferRequestsStatus/"
                        ? "active"
                        : ""
                      }`}
                    id="navbar-link1"
                    onClick={() =>
                      setActiveLink("/SRFund/manager/TransferRequestsStatus/")
                    }
                  >
                    <button className="value">
                      <FontAwesomeIcon icon={faTicket} />
                      &nbsp;
                      {jsonData?.RequestsManager?.nameAR}
                    </button>
                  </Link>
                </>
              ) : (
                <></>
              )}
              {/* 
            
            EmployeeAdvanceAction
            */}
              {userRole?.includes("d9aa628b-c8ec-487b-8796-1293b942207a") ? (
                <>
                  <Link
                    to="/SRFund/manager/SetEvaluter/"
                    className={`navbar-link ${activeLink === "/SRFund/manager/SetEvaluter/"
                        ? "active"
                        : ""
                      }`}
                    id="navbar-link2"
                    onClick={() =>
                      setActiveLink("/SRFund/manager/SetEvaluter/")
                    }
                  >
                    <button className="value">
                      <FontAwesomeIcon icon={faGears} />
                      &nbsp;
                      {jsonData?.SetEvaluator?.nameAR}
                    </button>
                  </Link>

                  <Link
                    to="/SRFund/manager/EvaluatorTransfer/"
                    className={`navbar-link ${activeLink === "/SRFund/manager/EvaluatorTransfer/"
                        ? "active"
                        : ""
                      }`}
                    id="navbar-link2"
                    onClick={() =>
                      setActiveLink("/SRFund/manager/EvaluatorTransfer/")
                    }
                  >
                    <button className="value">
                      <FontAwesomeIcon icon={faPeopleArrows} />
                      &nbsp;
                      {jsonData?.TransferBetweenResidents?.nameAR}
                    </button>
                  </Link>



                  <Link
                    to="/SRFund/report/ReportStageRequest/"
                    className={`navbar-link ${activeLink === "/SRFund/report/ReportStageRequest/"
                        ? "active"
                        : ""
                      }`}
                    id="navbar-link2"
                    onClick={() =>
                      setActiveLink("/SRFund/report/ReportStageRequest/")
                    }
                  >
                    <button className="value">
                      <FontAwesomeIcon icon={faClipboardList} />
                      &nbsp;
                      {jsonData?.ReportStage?.nameAR}
                    </button>
                  </Link>
                </>
              ) : (
                <></>
              )}
              {/* 
      Evaluator
      */}
              {userRole?.includes("fd21937f-89d0-442e-8010-5b88e360bd48") ? (
                <>
                  <Link
                    to="/SRFund/manager/RequestsEvaluation/"
                    className={`navbar-link ${activeLink === "/SRFund/manager/RequestsEvaluation/"
                        ? "active"
                        : ""
                      }`}
                    id="navbar-link2"
                    onClick={() =>
                      setActiveLink("/SRFund/manager/RequestsEvaluation/")
                    }
                  >
                    <button className="value">
                      <FontAwesomeIcon icon={faTable} />
                      &nbsp;
                      {jsonData?.RequestsReferredArbitration?.nameAR}
                    </button>
                  </Link>
                </>
              ) : (
                <></>
              )}


              {
                userRole?.includes("059c649c-a4c6-47dc-9daa-fce7f32c51e8")||
                userRole?.includes("9ee77ff6-a48b-46c8-9eb6-1a2337810f19")?
                <Link
                  to="/SRFund/report/ReportStageRequest/"
                  className={`navbar-link ${activeLink === "/SRFund/report/ReportStageRequest/"
                      ? "active"
                      : ""
                    }`}
                  id="navbar-link2"
                  onClick={() =>
                    setActiveLink("/SRFund/report/ReportStageRequest/")
                  }
                >
                  <button className="value">
                    <FontAwesomeIcon icon={faClipboardList} />
                    &nbsp;
                    {jsonData?.ReportStage?.nameAR}
                  </button>
                </Link>
                :<></>
                
              }








              {/* 
            اللجنة العلمية
            */}
              {userRole?.includes("d9c9303e-2454-42b2-99e4-7f544b82b006") ? (
                <>
                  <Link
                    to="/SRFund/manager/ScientificCommittee/"
                    className={`navbar-link ${activeLink === "/SRFund/manager/ScientificCommittee/"
                        ? "active"
                        : ""
                      }`}
                    id="navbar-link2"
                    onClick={() =>
                      setActiveLink("/SRFund/manager/ScientificCommittee/")
                    }
                  >
                    <button className="value">
                      <FontAwesomeIcon icon={faTable} />
                      &nbsp;
                      {jsonData?.ScientificCommittee?.nameAR}
                    </button>
                  </Link>
                </>
              ) : (
                <></>
              )}
              {userRole?.includes("73c6d8f8-0796-4eeb-a788-383e5f63f8aa") ||
                userRole?.includes("d9aa628b-c8ec-487b-8796-1293b942207a")||
                userRole?.includes("9ee77ff6-a48b-46c8-9eb6-1a2337810f19") ? (
                <>
                  <Link
                    to="/SRFund/manager/AllApplicationRequest/"
                    className={`navbar-link ${activeLink === "/SRFund/manager/AllApplicationRequest/"
                        ? "active"
                        : ""
                      }`}
                    id="navbar-link2"
                    onClick={() =>
                      setActiveLink("/SRFund/manager/AllApplicationRequest/")
                    }
                  >
                    <button className="value">
                      <FontAwesomeIcon icon={faTable} />
                      &nbsp;
                      {jsonData?.AllRequests?.nameAR}
                    </button>
                  </Link>
                </>
              ) : (
                <></>
              )}

              {/* {state.RoleByUserGuid?.includes(
              "7382e598-e8b5-4077-aee6-cfdfd8b16e4f"
            ) ? (
              <Link
                to="/grants/manager/AssiginToEvaluters"
                className={`navbar-link ${
                  activeLink === "/grants/manager/AssiginToEvaluters"
                    ? "active"
                    : ""
                }`}
                id="navbar-link2"
                onClick={() =>
                  setActiveLink("/grants/manager/AssiginToEvaluters")
                }
              >
                <button className="value">
                  <FontAwesomeIcon icon={faUserPlus} />
                  &nbsp;
                  {jsonData.AssiginToEvaluters.nameAR}
                </button>
              </Link>
            ) : (
              ""
            )}
            {state.RoleByUserGuid?.includes(
              "ea4c6bb6-98f4-4618-befa-259847b5db64"
            ) ? (
              <Link
                to="/grants/manager/MyRequestsPage"
                className={`navbar-link ${
                  activeLink === "/grants/manager/MyRequestsPage"
                    ? "active"
                    : ""
                }`}
                id="navbar-link2"
                onClick={() => setActiveLink("/grants/manager/MyRequestsPage")}
              >
                <button className="value">
                  <FontAwesomeIcon icon={faTable} />
                  &nbsp;
                  {jsonData.MyRequestsManager.nameAR}
                </button>
              </Link>
            ) : (
              ""
            )}
            <Link
              to="/grants/manager/Report"
              className={`navbar-link ${
                activeLink === "/grants/manager/Report" ? "active" : ""
              }`}
              id="navbar-link2"
              onClick={() => setActiveLink("/grants/manager/Report")}
            >
              <button className="value">
                <FontAwesomeIcon icon={faGears} />
                &nbsp;
                {jsonData.RS_ReportStagesNav.nameAR}
              </button>
            </Link> */}
            </div>
          </div>
        ) : (
          ""
        )}
      </>
    </>
  );
  return <>{HTML}</>;
}

export default NavBarManager;
